import { useTranslation } from 'react-i18next';

import { Container } from '@/components';
import { useBreadcrumbs } from '@/features/header';
import { MyOpportunityDetail } from '@/features/opportunities/components/my-opportunities/detail';

export function MyOpportunityView() {
  const { t } = useTranslation(['opportunities']);

  useBreadcrumbs(() => [{ title: t(`Seller Dashboard`) }]);

  return <MyOpportunityDetail />;
}
